import { HighlightedCode } from "~/pages/manifold-nextgen/components/conversations/HighlightedCode";

interface ArtifactCodeProps {
  code: string;
  // The conversations-api emits Python today, but TEXT artifacts can hold
  // anything — let callers override when they know the language.
  language?: "python" | "sql" | "json" | "bash" | "yaml";
}

// Syntax-highlighted code block with a copy button. Rendered as the expanded
// body of the toolbar's "Code" toggle in ArtifactShell. Uses the Prism theme's
// own background and is height-capped since artifacts can be long.
export const ArtifactCode = ({ code, language = "python" }: ArtifactCodeProps) => (
  <HighlightedCode
    code={code}
    language={language}
    className="max-h-72 overflow-auto px-3 py-2 pr-10 text-[0.8125rem] leading-5"
    useThemeBackground
  />
);
